import React, { forwardRef } from 'react';
import { Form as FormUI } from '@ui-framework/index';
import * as FormFields from '../FormFields/index';

const Form = forwardRef((props, ref) => {
  const { customComponents, ...rest } = props;
  return (
    <FormUI
      ref={ref}
      customComponents={{
        ...(props?.customComponents || {}),
        ...FormFields,
      }}
      {...rest}>
      {props?.children}
    </FormUI>
  );
});

export default Form;
